/**
 * =========================================================================================
 * Component - Input
 * =========================================================================================
 *
 **/

import React, {useEffect, useMemo, useState} from 'react';
import * as Icon from 'ubs-icons';
import { COLOR } from '../common/constant';
import { ISkeleton } from '../skeleton/input-skeleton';
import UPopup from "ubs-framework/v2/UPopup";

const UInput = React.memo((props) => {

    const [error, setError] = useState(null);

    useEffect(() => {
        let msg = props?.hasError?.props?.children || props?.hasError;
        if (msg) {
            let i = msg?.search('index');
            if (i >= 0) {
                i = msg?.substr(i, 6);
                msg = msg?.replace(i, '');
            }
            msg = msg?.replace('The', '').replace('field', '');
            msg = msg?.replace('and', '-')
            // msg = msg?.replace('must be', 'at least')
            if (msg?.includes('is required.')) setError('Required*');
            else if (msg?.includes('the required pattern.')) setError(`${props?.label} must be valid.`);
            else setError(msg)
        }
    }, [props?.hasError]);

    // Get Classnames
    const classNames = useMemo(() => {
        let classes = 'u_input';

        if (props?.className) classes += ` ${props?.className}`;
        if (props?.isFocused) classes += ' u_input-focused';
        if (props?.select) classes += ' u_input-select';
        if (props?.selectValue) classes += ' u_input-select-value';
        if (props?.textarea) classes += ' u_input-textarea';
        if (props?.datepicker) classes += ' u_input-datepicker';
        if (props?.selectDate) classes += ' u_input-date-select';
        if (props?.social) classes += ' u_input-social';
        if (props?.notice) classes += ' u_input-notice';
        if (props?.password) classes += ' u_input-password';
        if (props?.hasError) classes += ' u_input-error';
        if (props?.hoursMinutes) classes += ' u_hoursMinutes';

        return classes;
    }, [props?.className, props?.isFocused, props?.select, props?.selectValue, props?.textarea, props?.datepicker, props?.selectDate, props?.social, props?.notice, props?.hasError, props?.hoursMinutes, props?.password])

    useEffect(() => {
        const keyDown = e => {
            if (e.target.type === 'number') {
                if (["Space", "ArrowUp", "ArrowDown"].indexOf(e.code) > -1) e.preventDefault();
            }
        }

        window.addEventListener("keydown", keyDown, false);
        return () => window.removeEventListener("keydown", keyDown, false);
    }, [])

    return (
        <React.Fragment>
            {props?.isLoading ?
                <ISkeleton/>
                :
                <div className={classNames} data-testid={props?.['data-testid'] || (props?.label ? `wrapper-${props?.label?.toLowerCase().replace(/\s+/g, '-')}` : undefined)}>
                    <div className="u_relative u_w-full">
                        {props?.children}

                        {props?.label && <label>{props?.label} {props?.asterisk && <span className="u_asterisk-sign">*</span>}</label>}

                        {props?.hasError &&
                        <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['click', 'hover']}} desc={<span className='u_text-c'>{error}</span>}>
                                <span className="u_required u_required-icon u_cp">
                                    {props?.icon ? props?.icon : <Icon.Warning size={16} fill={COLOR.u_white}/>}
                                </span>
                        </UPopup>}

                        {(props?.note || props?.selectNote) && <div className="u_input-note u_ib">
                            <UPopup
                                params={{className: "u_tooltip u_tooltip-full u_tooltip-customNote", on: ['click', 'hover']}}
                                desc={<span dangerouslySetInnerHTML={{__html: props?.note || props?.selectNote}}/>}
                            >
                                    <span className="u_rollover u_cp u_flex">
                                        <Icon.InfoTooltip fill={COLOR.u_icon_bg} size={18}/>
                                    </span>
                            </UPopup>
                        </div>}
                    </div>
                    {props?.infoLabel && <span className="u_fix-label u_infoLabel u_ib">{props?.infoLabel}</span>}
                </div>
            }

        </React.Fragment>
    );
});

export default UInput;